import React, {useState, useRef} from "react";
import Logo from "../../assets/logo/domecq_academy.png";
import {VerifyStyled} from "./components/Styles";
import Text from "../../styles/Text";
import Color from "../../assets/Colors";
import Button from "../../styles/Button";
import {returnAge} from "../../constants/Helpers";

export default function Verify({updateStatus}) {
   let inputDay = useRef(null);
   let inputMonth = useRef(null); 
   let inputYear = useRef(null);
   const [errorAge, setErrorage] = useState();
   const [valueDate, setDates] = useState({days: "", month: "", year: ""});

   const validityAge = (e) => {
      e.preventDefault();
      setErrorage(false);
      const {year, month, day} = e.target;
      if (!year.value || !month.value || !day.value) return false;
      const currentDate = new Date(year.value, month.value - 1, day.value);
      // validar si el año de nacimiento es mayor al actula menos 18
      const isAdult = returnAge(currentDate) >= 18;
      // si es mayor actulizar el hook anterior
      if (isAdult) {
         updateStatus(isAdult);
      } else {
         setErrorage(true);
      }
   };

   const validText = (maxL, target, val) => {
      let minYear = new Date().getFullYear() - 100 + "";
      let maxYear = new Date().getFullYear() - 17 + "";

      switch (target) {
         case "days":
            let mMaxD = [1, 31];
            if (val.length < maxL) {
               // si es menor al length permitido simplmente imprime
               return setVal(target, val);
            } else if (val >= mMaxD[0] && val <= mMaxD[1]) {
               // valida los valores si se llegó al limite
               setVal(target, val);
               return inputMonth.current.focus();
            }
            break;
         case "month":
            let mMaxM = [1, 12];
            if (val.length < maxL) {
               // si es menor al length permitido simplmente imprime
               return setVal(target, val);
            } else if (val >= mMaxM[0] && val <= mMaxM[1]) {
               // valida los valores si se llegó al limite
               setVal(target, val);
               return inputYear.current.focus();
            }
            break;
         case "year":
            let minYear = new Date().getFullYear() - 100;
            let maxYear = new Date().getFullYear() - 18;
            if (val.length < maxL) {
               // si es menor al length permitido simplmente imprime
               return setVal(target, val);
            } else {
               if (val >= minYear && val <= maxYear) {
                  // valida los valores si se llegó al limite
                  return setVal(target, val);
               } else {
                  setVal(target, "");
               }
            }
            break;
         default:
            break;
      }

      function setVal(targetA, valA) {
         let newDaa = {...valueDate, [targetA]: valA};
         setDates(newDaa);
      }
   };

   return (
      <VerifyStyled>
         <img src={Logo} alt="domecq" width="200px" className="logo" />
         <Text size="3em" className="title">
            Bienvenido a <br />
            Domecq Academy
         </Text>
         <Text size="1.48em" color={Color.textColor} className="text" weight="100">
            Debes ser mayor de edad para acceder a este sitio. <br />
            Por favor ingresa tu fecha de nacimiento.
         </Text>
         <form onSubmit={validityAge} className="ageForm">
            <div>
               <input
                  type="number"
                  placeholder="DD"
                  name="day"
                  max="31"
                  maxLength="2"
                  value={valueDate.days}
                  ref={inputDay}
                  onChange={(e) => validText(2, "days", e.target.value)}
               />
               <span className="line" />
               <input
                  type="number"
                  placeholder="MM"
                  name="month"
                  max="12"
                  maxLength="2"
                  value={valueDate.month}
                  ref={inputMonth}
                  onChange={(e) => validText(2, "month", e.target.value)}
               />
               <span className="line" />
               <input
                  type="number"
                  placeholder="YYYY"
                  name="year"
                  min={new Date().getFullYear() - 100}
                  maxLength="4"
                  ref={inputYear}
                  onChange={(e) => validText(4, "year", e.target.value)}
                  value={valueDate.year}
               />
            </div>
            {errorAge && (
               <Text size="1.1em" lineHeight="1.4em" color="crimson" className="text disc" weight="100">
                  Este sitio es solo para mayores de edad.
               </Text>
            )}
            <Button size="1.4em">ENTRAR</Button>
         </form>
         <Text size="1.1em" lineHeight="1.4em" color={Color.textColor} className="text disc" weight="100">
            Al dar clic en ENTRAR el usuario manifiesta y garantiza a <br /> Domecq Academy que es mayor de edad y apto para <br />{" "}
            visualizar el contenido
         </Text>
      </VerifyStyled>
   );
}
